import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timer', standalone: true })
export class TimerPipe implements PipeTransform {
  transform(duration: number, max: number | undefined = undefined) {
    const s: number = Math.floor(duration % 60);
    const m: number = Math.floor(((duration % 3600) - s) / 60);
    const h: number = Math.floor((duration - m * 60 - s) / 3600);
    const sec: string = s < 10 ? '0' + s : s.toString();
    const min: string = m < 10 ? '0' + m : m.toString();
    const hour: string = h < 10 ? '0' + h : h.toString();
    if (!max || max > 3600) {
      return `${hour}:${min}:${sec}`;
    }
    return `${min}:${sec}`;
  }
}
